var en = {
  pushTip: {
    pushType0: "The push has {nums} devices have been completed push, you want to skip these devices?",
    pushSuccess: "Jump to task details to see push schedule?",
    push_all_by_mem: "Whether to push channel operators: all the equipment under the {mem}",
    push_all: "Are you pushing all the equipment under all channels?",
  },
  ter: {
    state1: 'Activation successful',
    state2: 'Activation failed',
    state3: 'Wait for activation',
    mechName: 'Merchant',
    status: 'Status',
    createTime:'CreateTime',
    terminalNo: 'Terminal number',
     msg: 'Do you want to delete',
  },
  IncorrectaFormat: 'Wrong Format. Please Upload Xls Or Xlsx File',//new 7/9
  app_certificate_1: "Level 1 Certificate",
  app_certificate_2: "Level 2 Certificate",
  app_certificate_1_psp: "Chip firmware",
  app_certificate_2_psp: "Master firmware",
  app_pushAll: "Push All Terminal",
  app_uploadApp: 'Upload application',
  app_No: 'Serial number',
  app_terNo: 'Terminal number',
  app_name: 'Name',
  psp_app_id: "ID app",
  psp_app_version: "Version app",
  app_appName: 'Application name',
  psp_app_manage: "Application management",
  psp_unstall_manage: "Uninstall management",
  app_appUpList: "Apply device update list",
  app_appType: 'Application type',
  app_insType: 'Installation type',
  app_vStatus: 'Status',
  app_ulTime: 'Upload time',
  app_appLoding: 'Application uploading',
  app_newgVer: 'Latest version',
  app_operate: 'Operation',
  app_type: 'Type',
  app_del: 'Delete',
  app_pause: 'Pause',
  app_continue: 'Continue',
  app_status: 'Status',
  app_new: 'New add',
  app_yes: 'Yes',
  app_no: 'No',
  app_selectAll: 'Select all',
  app_save: 'Save',
  app_process: 'Progress',
  app_push: 'Confirm push',
  app_terminal: 'Terminal',
  app_to: ' to ',
  app_offShelf: 'Remove',
  app_mulOffShelf: 'Batch remove',
  app_isOffShelf: 'Are you sure to remove the application from the store?',
  app_isDelApp: 'Are you sure to delete the application?',
  app_chooseOneMust: 'Select one application at least',
  app_cantDelTask: 'Tasks selected include some cannot be deleted',
  app_oneRecordMust: 'Select at least one record',
  app_phoneIllegal: 'Phone number is not legal',
  app_groupName: 'Category Name',
  app_sure: 'Yes',
  app_query: 'Query',
  app_reset: 'Reset',
  app_cancel: 'Cancel',
  app_edit: 'Edit',
  app_add: 'Add',
  app_verify: 'Review',
  app_isPass: 'Result',
  app_pass: 'Approved',
  app_ban: 'Rejected',
  app_noInput: 'Unfilled',
  app_banReason: 'Refuse reason',
  app_filter: 'Filter',
  app_prePushVerify: 'Waiting for submitting',
  app_preVerify: 'waiting for review',
  app_verifyPass: 'Approved',
  app_verifyNotPass: 'Rejected',
  app_success: 'Successful',
  app_submit: 'Submit',
  app_tip: 'Prompt',
  app_online: 'Online',
  app_offline: 'Offline',
  app_fileOver: 'File exceed',
  app_onlyApk: 'Apk files upload only',
  app_onlyApk_2: 'Apk/Hap files upload only',
  app_tipViewTask: 'Push successfully, please view progress in task management',
  app_tipMkDel: 'Application in app store will be deleted synchronously. Are you sure to delete?',
  app_clearTask: 'Do you want to clear all devices?',
  app_tipAppEdit: 'Deleted will not be restored, sure to delete?',
  app_tipVerify: 'Are you sure to submit?',
  app_rqsError: 'Request error',
  app_not_auth: 'TMS not activated',
  app_mulAdd: 'Batch add',
  app_select: 'Select',
  app_input: 'Please enter the content',
  app_inputCp: 'Please fill in complete',
  app_inputName: 'Please enter a name',
  app_inputContact: 'Please enter a contact',
  app_inputTruePhone: 'Please enter the correct number',
  app_inputAddr: 'Please enter an address',
  app_inputVer: 'Please enter the version',
  app_inputVerTag: 'Please enter the version ID',
  app_inputID: 'Please enter Identification',
  app_inputPkg: 'Please enter the packagename',
  app_noVerTag: 'No versionCode',
  app_inputIntrol: 'Please enter a description',
  app_selectType: 'Please select the application type',
  app_ulApp: 'Please upload the application',
  app_ulIcon: 'Please upload a small icon',
  app_ulLarIcon: 'Please upload a big icon',
  app_ulScreenShot: 'Please upload screenshots',
  app_smVerify: 'Submit',
  app_baseInfo: 'Basic Information',
  app_version: 'VersionName',
  app_autoUpload: 'Automatically enter',
  app_verTag: 'VersionCode',
  app_ID: 'Identification',
  app_package: 'Packagename',
  app_introl: 'Application brief',
  app_udState: 'Update notes',
  app_icon: 'Small icon',
  app_larIcon: 'Large icon',
  app_screenShot: 'Screenshots',
  app_appVer: 'Application version',
  app_createTime: 'Create time',
  app_close: 'Close',
  app_ulNew: 'Upload latest version',
  app_selectApp: 'Select application',
  app_testInstall: 'Test for installation',
  app_ulAppState: 'Drag the file here, or click upload, only apk file upload is supported',
  app_clickUpdate: 'Click upload',
  app_udType: 'The way for update',
  app_allUpdate: 'Update all',
  app_iconState: '144x144,Size does not exceed 100k',
  app_larIconState: '512x512,Size does not exceed 200k',
  app_autoInstall: 'Automatic installation',
  app_addApp: 'Add',
  app_classIntrol: 'Classification recommended',
  app_homeIntrol: 'Home recommended',
  app_isIntroClass: 'Recommended to classification or not',
  app_isIntroHome: 'Recommended to home or not',
  app_isUnbindApp: 'Are you sure to uninstall the application？',
  app_isOffApp: 'Are you sure Shelf application?',
  app_isDelData: 'Are you sure to delete this data?',
  app_inputAName: 'Please enter a name',
  app_oneDeviceMust: 'Select one device at least',
  app_fileSize: 'File size',
  app_addPush: 'Add push',
  app_viewPushHis: 'View push history',
  app_pushTimes: 'Download',
  app_hisVer: 'Historic version',
  app_pushHistory: 'Push history',
  app_pushInstall: 'Test install',
  app_animatePush: 'Animation',
  app_animateMake: 'New',
  app_pushDevice: 'Pushed device',
  app_deviceNum: 'Total',
  app_deviceName: 'Device name',
  app_deviceNo: 'Device number',
  app_pushTime: 'Push time',
  app_distributor: 'Merchant',
  app_dParent: 'Parent merchant',
  app_unbind: 'Uninstall',
  app_mulUnbind: 'Batch uninstall',
  app_mulPush: 'Batch push',
  app_searchTerminal: 'Find devices',
  app_terName: 'Terminal name',
  app_taskName: 'Task name',
  app_taskDetail: 'Task content',
  app_deviceTotal: 'Total number of devices',
  app_downloading: 'Downloading',
  app_downFail: 'Failed to download',
  app_update: 'Update',
  app_md5Fail: 'MD5 verification failed',
  app_theNewgVer: 'latest version alreaday installed',
  app_fileFmIllegal: 'The file format is incorrect',
  app_updateFail: 'Failed to update',
  app_usrCancelUpdate: 'The user canceled the update',
  app_pushFail: 'Device offline',
  app_downFinish: 'Download completed',
  app_updateSuccess: 'Update sucessfully',
  app_fail: 'Failed',
  app_addres: 'Address',
  app_mulDel: 'Batch deleted',
  app_allDel: 'Delete all',
  app_contact: 'Contacts',
  app_contactPhone: 'contact number',
  app_typeName: 'Type name',
  app_customs: 'Create',
  app_clear: 'Clean',
  app_customsTime: 'Create time',
  app_launchAnimate: 'Boot Animation',
  app_onLogo: 'Boot LOGO',
  app_animateName: 'Animation name',
  app_playPlace: 'Play position',
  app_aSrcFile: 'Animation resource file',
  app_asfState: 'Animated image, Note that the file name must be part0.zip',
  app_downExp: 'Download example',
  app_ologoState: 'The screen displayed after the movie playback stops',
  app_picSize: 'Image size',
  app_picSizeState: 'Enter the width*height',
  app_frame: 'Number of frames',
  app_frameState: 'Number of animations played per second',
  app_aCycleTime: 'Number of animation cycles',
  app_cyclePlay: 'Loop Playback',
  app_playOnce: 'Play once',
  app_fileNameOnly: 'File name must be',
  app_inputNumber: 'Please enter the number',
  app_picUlError: 'Image upload error',
  app_inputAnimateName: 'Please enter an animation name',
  app_selectAnimateType: 'Please select the animation type',
  app_selectPlayPlace: 'Please select a play position',
  app_uploadAnimateFile: 'Please upload an animation file',
  app_uploadOnPic: 'Please upload the boot picture',
  app_sureDelTip: 'Are you sure to delete? It will not be restored after deletion',
  app_uploadPic: 'Please upload pictures',
  app_launchUI: 'Start interface',
  app_amechine: '',
  app_chooseCycleType: 'Please select the loop mode',
  app_formatNotTrueLike: 'The format is incorrect',
  app_on: 'Power on',
  app_off: 'Power off',
  app_onOff: 'Power on or Power off',
  app_firm: 'Manufacturer name',
  // 2017-7-28 wei add
  add_srcFwByName: 'Find the firmware by name',
  app_downNum: 'Downloads',
  app_pushed: 'Released',
  app_notPass: 'Rejected',
  app_sysType: 'System type',
  app_sys: 'System',
  app_sysUdPack: 'System upgrade package',
  app_chooseFile: 'Select a file',
  app_signCer: 'Signature certificate',
  app_isUseDisCerAutoSign: 'Whether to use the merchant certificate for automatic signature',
  app_useDis: 'Designated merchant',
  app_allDisUsed: 'Common for all merchant',
  app_pushInstallTest: 'Test',
  app_firmware: 'Firmware name',
  app_pushType: 'Push type',
  app_dv: 'Device',
  // 2017-7-31 wei add
  app_fwType: 'Firmware type',
  app_ulNormalSt: 'Drag the file here, or click upload',
  app_selectChannel: 'Please select merchant',
  app_isSubmitToCheck: 'Do you want to submit for review',
  app_pleaseInputNo: 'Please enter terminal number',
  app_cnAndActive: 'Online activate',
  app_clearCer: 'Clear certificate',
  app_ofCheck: 'Verification',
  app_normal: 'Normal',
  app_netStatus: 'Network status',
  app_active: 'Activated',
  app_initiative: 'initiative',
  app_selfDestroy: 'Self-destruction',
  app_mulActive: 'Active in batch',
  app_selected: 'Selected',
  app_cerCheckOf: 'Verify switch',
  app_openCerCheck: 'Verify on',
  app_closeCerCheck: 'Verify off',
  app_reOpen: 'Reopen',
  app_reClose: 'Reclose',
  app_open: 'Open',
  app_usrManage: 'User manage',
  app_stManage: 'Configuration manage',
  app_roleManage: 'Role manage',
  // 2017-8-8 wei add
  app_cerMgType: 'Certificate manage',
  app_cerMgSelf: 'Self-Manage',
  app_cerMgOther: 'Platform-Manage',
  app_cerMgCustomer: 'Customized',
  app_operateHis: 'Operation record',
  app_operateType: 'Operation Type',
  app_time: 'Time',
  app_isActive: 'Activate?',
  // 2017-8-8 wei add
  app_downCer: 'Download certificate',
  // 2017-8-10 wei add
  app_isOperate: 'Continue?',
  // 2017-8-11 wei add
  app_ulSuccess: 'Upload success',
  // 2017-7-31 wei add
  app_setting: 'Setting',
  // 2017-8-15 wei add
  app_clickPicToUlPic: 'Click to upload img',
  app_within: 'within',
  app_pgsFormat: 'Format(png, gif, svg)',
  app_sgUseAndAdUse: 'Format:svg, white color recommanded',
  app_sureChange: 'Confirm change',
  app_logoLvTip: 'Exit without saving?',
  app_dfIcon: 'Default icon',
  // 2017-8-16 wei add
  app_useBigSize: 'Big size',
  app_useBigSizeTip: 'Click to optimize view',
  // 2017-8-22 wei add
  app_or: 'Or',
  app_format: 'Format',
  app_pic: 'Picture',
  app_s: " 's ",
  app_plsUpl: 'Please Upload',
  // 2017-8-24
  app_upload: 'Upload',
  app_cerType: 'Certificate Type',
  // 2017-8-31
  app_editProfile: 'Edit Profile',
  // 2017-9-1
  app_cerFile: 'Certificate files',
  app_plsUlPbCer: 'Please upload customer certificate',
  app_appNoCerTip: 'The current channel is self managing certificate channel, please upload public key file for application verification',
  app_appNeedCerTip: 'The current channel does not have a certificate, please contact the platform administrator to create',
  app_createCer: 'Create certificate',
  app_uploadCer: 'Upload certificate',
  app_ustart: 'Not started',
  app_outofdate: 'Expired',
  // 2017-9-4
  app_fileImport: 'File import',
  app_mdFile: 'Template file',
  app_down: 'Download',
  // 2017-9-5
  app_roleAllot: 'Role allot',
  app_roleName: 'Role',
  app_downTplFile: 'Download template files',
  // 2017-9-7
  app_verUdCt: 'Version update contents',
  app_animation: 'animation',
  app_per: 'per',
  app_minute: 'minute',
  app_autoRefresh: 'auto refresh',
  app_level: 'level',
  app_firm: 'company',
  app_model: 'model',
  app_adType: 'Advertisement type',
  app_license: 'license key',
  app_maintain: 'maintain',
  app_manage: 'manage',
  app_is: 'is',
  app_plsip: 'please input',
  app_reason: 'reason',
  //2017 9-26
  app_sgMc: 'single machine',
  app_ss: 'synopsis',
  app_inst: 'install',
  app_file: 'file',
  app_printscreen: 'printscreen',
  app_batch: 'batch',
  app_recov: 'recovery',
  app_lc: 'launcher',
  // 2017 10-11
  app_re: 'again',
  app_confirm: 'confirm',
  app_df: 'default',
  app_as: 'as',
  app_click: 'click',
  app_content: 'content',
  app_ttPkg: 'Full package',
  app_dfPkg: 'Incremental package',
  app_task: 'task',
  app_catch: 'catch',
  app_log: 'Log',
  app_continued: 'continued',
  app_sec: 'second',
  app_video: 'video',
  app_ad: 'ad',
  // 2017 10-25
  app_choose: 'choose',
  app_timeInterval: 'time interval',
  app_and: 'and',
  app_play: 'play',
  app_times: 'times',
  app_sc: 'second',
  app_tofvalis: 'Term of validity',
  app_tofvaliss: 'Term of validity',
  app_start: 'start',
  app_end: 'end',
  app_preview: 'preview',
  app_duration: 'duration',
  app_size: 'size',
  app_personnel: 'personnel',
  app_cannot: 'cannot',
  app_early: 'early',
  app_later: 'later',
  app_lessThan: 'less than',
  app_moreThan: 'more than',
  // 2017 11-14
  app_nums: 'numbers',
  app_waiting: 'waiting',
  app_all: 'all',
  app_all1: 'all',
  app_thistime: 'this time',
  app_done: 'done',
  app_areyou: 'are you',
  app_skip: 'skip',
  app_these: 'these',
  app_cover: 'cover',
  app_jump: 'jump',
  app_detail: 'detail',
  app_view: 'view',
  app_now: 'now',
  app_imp: 'import',
  app_size1: 'size',
  app_taskMg: 'Task manage',
  app_taskType: 'Task type',
  app_cancelPush: 'Cancel push',
  app_azcgsj: 'time of install success',
  app_ispushf: 'To install remotely',
  app_autoscopen: 'Run automatically when finish install',
  app_pushsctipinstall: 'Prompt install when download finish',
  app_tipdown: 'Prompt download',
  app_tipud: 'Prompt update',
  app_sysinfo: 'System info',
  app_bth: 'Back to home',
  app_terstatus: 'Terminal status',
  app_fminfo: 'Firmware info',
  app_norightview: 'You do not have access to this page',
  // 2017 11-27
  app_fault: 'fault',
  app_geo: 'geography',
  app_abnormal: 'abnormal',
  app_blockp: 'Block paper',
  app_ecr: 'Electric card reader',
  app_mcr: 'Manual card reader',
  app_nacr: 'Non access card reader',
  app_cardr: 'Card reader',
  app_rcmsg: 'Recieve message',
  app_tgcr: 'Two generation card reader',
  app_receiptp: 'Receipt printer ',
  app_hbsp: 'Geartbeat interval',
  app_checkupsp: 'Check update interval',
  app_ispushalldv: 'Is push all device',
  //edit lin
  lin_btn: {
    cancel: "Cancel",
    add: "Add",
    install: 'install',
    batch_install: 'Batch install',
    tips: 'Prompt',
    confirm: 'Confirm',
    unbind: 'Unbind',
    unbindAll: 'Batch unbind',
    check: 'Query',
    reset: 'Reset',
    submit: 'Submit',
    restart: 'Reboot',
    off: 'Close',
    send: 'Push',
    batch_delete: 'Batch Delete',
    delete: 'Delete',
    lock: 'Lock',
    lockOta: 'Lock OTA',
    add_zeng: 'Add',
    edit: 'Edit',
    save: 'Save',
    bind: 'Bind',
    //20170727新增edit by linziying
    bindAll: 'Batch bind',
    xiezai: 'Uninstall',
    unlock: 'Unlock',
    change: 'Modify',

  },
  lin_global: {
    cs_config: 'Param setting',
    task_tips: 'The installation is successful, please view the progress of the push in the task management',
    task_tips2: 'Push sucessfully，please view the progress of the push in Task Management',
    ope: 'Operation',
    pselect: 'Please select',
    label_no: 'Serial Number',
    loading: 'Loading',
    label_name: 'Name',
    all_mechanism: 'All merchant',
    place_areaid: 'Please select merchant',
    time: 'Time',
    version: 'Version',
    name: 'Name',
    remark: 'Remark',
    edit: 'Edit',
    label_model: 'Device model',
    label_type: 'Device type',
    device_type_1: "Intelligent POS",
    device_type_2: "Other equipment",
    label_manufid: 'Manufacturer',
    label_areaid: 'Merchant',
    label_areaid_name: 'Merchant name',
    label_address: 'Address',
    ter_status: 'Status',
    dest_status: 'Active status',
    net_status: 'Network',
    run_status: 'Peripherals',
    online: 'Online',
    offline: 'Offline',
    new_add: 'New-add',
    normal: 'Normal',
    marn: 'Warning',
    fault: 'Fault',
    success_tips: 'Successful operation',
    concel_tips: 'Canceled',
    zlxfs_tips: 'The order was issued successfully',
    sb_tips: 'Failed to operate, terminal is offline',
    czsb: 'Failed to operate',
    zl_error: 'Instruction issued error',
    all_status: 'All status',
    delete_success: 'Delete successfully',
    look_detail: 'View details',
    ter_num: 'Device quantity',
    ota_bao: 'OTA package',
    ple_sel_ota: 'Please select OTA package',
    unlock_success: 'Unlock successfully',
    risk_name: 'Configuration name',
    risk_type: 'Warning type',
    risk_radius: 'Fence radius(KM)',
    risk_city: 'Provinces and municipalities',
    risk_desc: 'Description',
    risk_warn_info: 'Risk control warning information',
    warn_event: 'Warning event',
    city: 'City',
    jwd: 'Latitude and longitude',
    distance: 'Beyond the set distance(KM)',
    ccwl: 'Beyond the fence',
    sbyj: 'Device warning',
    done: 'Done',
    undone: 'Untreated',
    roles_tips: 'Please select a role',
    roles_place: 'Nickname',
    userName: 'Username',
    nickName: 'Nickname',
    phoneNum: 'Mobile phone',
    roleName: 'Role',
    jh: 'Activate ',
    dj: 'Freeze',
    phoneNum2: 'Cellphone number',
    resetPass: 'Reset password',
    revisePass: 'Change password',
    oldPass: 'Old password',
    newPass: 'New password',
    comfirmPass: 'Confirm the new password',
    plePassTips: 'Please enter the password',
    plePassTipsAgain: 'Please enter the password again',
    pwdDisfault: 'Two passwords are not consistent',
    unfitPhone: 'Phone number is not legal',
    nickNameTips: 'Nickname cannot be null',
    userNameTips: 'Username cannot be null',
    phoneNumTips: 'Phone number cannot be null',
    roleidTips: 'Role cannot be null',
    mechanismIdTips: 'Merchant cannot be null',
    userStatusTips: 'Please set the user status',
    editPage: 'Edit page',
    addPage: 'Add page',
    status: 'Status',
    refs: 'Please improve the data',
    user: 'Account',
    logStartTime: 'Log start time',
    logEndTime: 'Log end time',
    download: 'Download',
    ddsc: 'Waiting for upload',
    scz: 'Uploading',
    scsb: 'Failed to upload',
    sccg: 'Uploaded successfully',
    rz_tips: 'Logs obtain successfully. Please view the progress of the log in log management',
    hqrz: 'Obtain the log',
    logoTitle: 'Terminal Management System',
    hello: 'Hello',
    wdzl: 'Your profile',
    tcxt: 'Sign out',
    yhdl: 'Sign in',
    zh: 'Account',
    password: 'Password',
    jzmm: 'Remember the password',
    login: 'Sign in',
    bah: 'Shenzhen Zhengtong Electronic Co., Ltd. © 1993-2020 copyright Guangdong ICP B No. 12035887',
    qsrzh: 'Please enter the username',
    qsrmm: 'Please enter the password',
    error: 'Error',
    wlzt: 'Network status',
    ckxq: 'View details',
    wlmc: 'Fence name',
    wllx: 'Fence type',
    bdsb: 'Bind the device',
    tjbd: 'Add binding',
    bjwl: 'Edit fence',
    wxzyjlx: 'Please select an warning type',
    cityName: 'City name',
    sfjxpljb: 'Batch unbundling or not',
    qxzyjbdzd: 'Please select the terminal to unbind',
    jbcg: 'Unbind successfully',
    sfjbczd: 'Unbind this terminal or not',
    sfjxplbd: 'Batch bundling or not',
    qxzybddzd: 'Please select the terminal to bind',
    bdcg: 'Bind successfully',
    sfbdczd: 'Bind this terminal or not',
    xzwl: 'Add fence',
    qdxysccwl: 'Are sure to delete this fence?',
    tsazcs: 'Test',
    shzt: 'status',
    pass: "Approved",
    notPass: "Rejected",
    waitOne: "Waiting for submit",
    waitTwo: "Waiting for review",
    shyy: 'Rejected reason',
    zdtslb: 'Terminal push list',
    xztghbtg: 'Select to pass or not',
    qrtj: 'Confirm submission',
    shcg: "Review successfully",
    syqdsty: 'Common for all merchant',
    notBlankName: "Name cannot be null",
    notBlankVer: 'Version cannot be null',
    qxzlx: 'Please select type',
    qxzscwj: 'Please select the upload file',
    zdqds: 'Designated merchant',
    sfsyzdqm: 'Whether to use the channel merchant certificate for automatic signature',
    qmzst: 'Signature certificate',
    azbdz: 'Installation package address',
    qscapkwj: 'Please upload apk file, and no more than 50M',
    qsczipwjls50: 'Please upload zip file, and no more than 50M',
    jwjtdcc: 'Drag the file here， or',
    djsc: 'Click upload',
    xgscwj: 'Modify the upload file',
    otaName: 'Name',
    xtlx: 'System type',
    syatemR: 'System ROM',
    sysjota: 'System upgrade package OTA',
    waitOne: "Waiting for submit",
    waitTwo: "Waiting for review",
    verifyPass: 'Approved',
    verifyNotPass: 'Rejected',
    confirmDelete: "Are you sure to delete？",
    tjshcg: 'Submit successfully',
    qdtjsh: 'Confirm to submit',
    allType: 'All type',
    smVerify: 'Submit approve',
    downNumber: 'Downloads',
    tgmccz: 'Find by name',
    upload: 'Upload',
    xzqddhwj: 'Select file of starting animation',
    qxzkjlogo: 'Select the boot LOGO',
    tpxzds: '300x300 is the best size for the picture, the volume is not greater than 2m',
    zmlaun: 'Select custom desktop launcher',
    xtjcb: 'Select the system base package',
    null: 'Null',
    shebei: 'Device',
    tslxxx: 'Push type',
    xzbbbbb: 'Select OTA package',
    uploadTime: "Upload time",
    verTips: 'Based on the version of the differential package, the version number does not contain characters such as V or version, such as 2.2.4.',
    verTips1: 'Version numbers do not contain characters such as V or version, pure numbers, such as 2.2.4',
    bbhgsbd: 'Format of version is incorrect',
    lkymtips: 'There are files that are being uploaded ，are you sure to leave this page',
    znscziptips: 'Zip files upload only',
    qsczipwj: 'Please upload Zip files',
    //20170727新增edit by linziying
    danweikm: 'Unit KM',
    weilanshuoming: 'Description: The latitude and longitude of the last heartbeat of the device is the center of the fence',
    pleaseUpload: 'Please upload',
    zdqmTips: 'Whether to bind the merchant certificate automatically signed',
    zhidingqdsxx: 'Designated merchant information',
    selectWenjian: 'Select file',
    qrjxmm: 'Are you sure to execute this command: ',
    cicaozuo: 'Operate?',
    shebeiedit: 'Device edit',
    yxpztitle: 'Mailbox configuration',
    yjyouxiang: 'Alarm mailbox',
    chongzhi: 'Reset',
    ljchangjian: 'Submit',
    ympeizhi: 'Domain name configuration',
    fwqdizhi: 'Server address',
    fwqdztips: 'Address does not include the "http: //" character, which can be either a domain address or an IP address, such as: www.baidu.com or 127.0.0.1',
    fwqduankou: 'Server port',
    duankoutips: 'Do not add ":" for the port number, directly fill in the numbers, such as: 8080',
    tuisongpeizhi: 'Modify',
    tuisongjl: 'Push record',
    tuisonglx: 'Push type',
    chenggong: 'Successful',
    shibai: "Failed",
    tuisongtime: 'Push time',
    chongtui: 'Push again',
    shebeibei: 'Device',
    fwqdzbnwk: 'The server address cannot be null',
    fwqdkhbnwk: 'The server port number cannot be null',
    wdct: 'Are you sure to push again',
    tuisongtips: 'Are you sure to modify the following IP configuration? New IP configuration will be effective after reboot.',
    //20170731 lin add
    china: 'Chinese',
    english: 'English',
    //20170804 lin add
    cjzs: 'Create certificate',
    createTime: 'Create time',
    certificateName: 'Certificate name',
    xiafa: 'Push',
    dachuzhengshu: 'Save certificate',
    guojia: 'Country',
    shengfen: 'Province',
    gongsi: 'Company',
    youxiang: 'Email',
    youxiaoqi: 'Expire date',
    certTypeLabel: 'Cert Type',
    certForManufacturer: 'manufacturer',
    certForCustomer: 'customer',
    danweitian: 'Unit: Day',
    xinjian: 'New',
    notNull: 'Must',
    bitian: 'Must',
    guojiatips: 'Country abbreviation',
    shenfentips: 'Province(ENG/CHN)',
    cityTips: ' City(ENG/CHN)',
    gongsiTips: 'Company(ENG/CHN)',
    emailTips: 'Email',
    youxiaoqiTips: 'Expire date, Unit: day',
    xuantian: 'Optional',
    srgsbzq: ' Wrong format',
    cszss: 'SZZT certificate',
    khzss: 'Distributor certificate',
    sccszss: 'Upload SZZT certificate',
    zhengshu: 'Certificate',
    qudaoshangxinxi: 'Merchant',
    quorter: 'Please confirm distributor or SN',
    xiafalishi: 'Download record',
    resXiafa: 'Re-download',
    chongxintuisong: 'Re-push',
    tuisongleixing: 'How to push',
    dachusiyao: 'Save private key',
    shuaxin: 'Refresh',
    passWordTips: 'Password required',
    //20170804 lin add end
    //20170821 lin add
    daochugongyao: 'Export certificate',
    //20170821 lin add end
    //20170822 lin add
    zhengshuType: 'Merchan Cert Type',
    ziguan: 'Self-manage',
    daiguan: 'Platform-manage',
    //20171023 add by sing
    add_merchant: 'Add Merchant'

  },
  //edit lin
  terminal: {
    //添加设备 Add device

    add: {
      //label值 Label value
      //放在global Place it on global

      //placeholder值 placeholder value
      place_no: "Please enter device number",
      place_name: 'Please enter device name',
      place_model: 'Please select device model ',    //also rules
      place_type: 'Please select device type ',     //also rules
      place_manufid: 'Please select manufacture',      //also rules
      //also rules
      place_address: 'Please enter device address',  //also rules
      //popover值 popover value
      popover_no: 'The device number consists of letters, numbers, or underscores whose length is no more than 50 digits',
      popover_name: 'The device name consists of Chinese characters, letters, numbers or underscores whose length is not greater than 50 digits',
      //校验规则 Check rules
      rules_no_1: 'The device number cannot be null',
      rules_no_2: 'The device number can not exceed 20 digits',
      rules_no_3: 'The device number consists of letters, numbers, or underscores',
      rules_no_4: 'The device number already exists',
      rules_name_1: 'The device name cannot be null',
      rules_name_2: 'The device name can not exceed 20 digits',
      rules_name_3: 'The device name consists of Chinese characters, letters, numbers, or underscores',
      //提交弹出提示Submit pop-up prompt
      success: 'Added successfully',
      change_success: 'Modified successfully',


    },
    appBind: {
      label_name: 'Application name',
      label_version: 'Version',
      label_size: 'Application size',
      place_name: 'Search by name',
      place_terminal: 'Please select the Terminal',
      empty_tips: 'Please select the application you want to bind!',
      install_tips: 'Are you sure to install this application?',
      five_tips: 'Binding application once can not be more than five',

    },
    appList: {
      label_name: 'Application name',
      label_type: 'Application type',
      label_version: 'Version',
      label_time: 'Binding time',
      format_status1: 'General application',
      format_status2: 'System applications',
      tips1: 'Are you sure to uninstall this app?',
      tips2: 'Unbind successfully',

    },
    appLog: {
      start_time: 'Start time',
      end_time: 'End Time',
      log_type: 'Log type',
      log_content: 'Log content',


      num: 'Device quantity',
      tower: '',

    },
    details: {
      regain: 'Reset',
      run_log: 'Running log',
      risk_info: 'Risk control information',
      app_list: 'APP list',
      app_install: 'APP install',
      send_animate: 'Push animation',
      reset_animate: 'Restore animation',
      base_info: 'Basic Information',
      system_info: 'System message',
      launcher: 'launcher version',
      system_version: 'System version',
      system_spversion: 'System spversion',
      ota_version: 'OTA version',
      hard_version: 'Firmware version',
      last_time: 'Last updated',
      net_type: 'Network type',
      online_time: 'Online time',
      run_time: 'Uptime',
      hard_info: 'Hardware information',
      Electric_quantity: "Electric quantity",
      network: "Network",
      cpu: 'CPU information',
      mem: 'Memory information',
      cpuUsed: 'CPU usage',
      memUsed: 'Memory usage',
      hydh: 'Restore animation',
      tips: 'Please select the animation restore type',
      kjdh: 'Boot animation',
      gjdh: 'Shutdown animation',
      kjlogo: 'Boot LOGO',
      alldhlogo: 'All（animation and LOGO）',
      zbhy: 'Cancel',
      mshy: 'Restore immediately',
      tsdh_title: 'Push animation',
      animate_name: 'Animation name',
      animatType: 'Type',
      position: 'Play position',
      createTime: 'Custom time',
      animate: 'Animation',
      kjlogo: 'Boot Logo',
      kj: 'Power on',
      gj: 'Power off',
      kgj: 'Power on or Power off',
      com_send: 'Comfirm to Push',
      cover_send: 'Coverage push',
      skip_send: 'Skip push',
      comfirm_send: 'Are you sure to push this animation',
      comfirm_hy: 'Are you sure to restore this animation?',
      hy_success: 'Restore successfully',
      hy_type: 'Please select the restore animation type',
      open_abd: 'Open ADB',
      close_abd: 'Close ADB',
      if_ope: 'Do this or not',

    },
    list: {
      add_btn: 'Add',
      import_btn: 'Import',
      ztgxsj: 'Last updated',
      ac_time: "Tms activate time",
      ec_time: "Expiration time",
      import_title: 'Import device information',
      xqwj: 'Select the file',
      qrdr: 'Are you sure to import?',
      import_muban: 'Download the import template',
      notify_title: 'Import results prompt',
      delete_tips: 'This operation will permanently delete the device, are you sure to continue?',
      deletes_tips: 'This operation will permanently delete the device, are you sure to continue?',
      empty_tips: 'Please select the device to be deleted',
      /*20170731新加*/
      excel_tips: 'Only Excel files not exceed 10M can be uploaded',

    },
    OtaList: {
      lock_num: 'Version Locked',
      lock_tips: 'Are you sure to unlock this OTA?',

    },
    terRisk: {
      fkpz: 'Risk control configuration',
    }
  },
  account: {
    delete_tips: 'Are you sure to delete this user?',
  },

  // edit mao
  mao_global: {
    btn: {
      sort: "sort",
      e: "Operation",
      cancel: "Cancel",
      add: "Add",
      edit: "Edit",
      submit: "Submit",
      update: "Modify",
      delete: "Delete",
      ok: "Confirm",
      selectAll: "Select all",
      unSelectAll: "Unselect all",
      reset: "Reset",
      createNow: "Submit",
      confirmUpdate: "Modify"
    },
    tip: {
      text: "Prompt",
      confirmDelete: "Are you sure to delete?",
      examine: "Review",
      pleaseSelect: "Please select",
      pleaseInput: "Please input",
      search: "Query",
      notBlank: "Cannot be null",
      success: "Successful",
      fail: "Failed",
      notPassExamine: "Rejected",
      groundsForRefusal: "Please enter the reason for refusal",
      notReset: "It will not be restored after deletion"
    }
  },
  /*菜单*/
  menu: {
    home: "Home",
    terManage: "Device",
    terManageSub: {
      myTer: "My Device",
      breakup: "Terminal Backup",
      lockOTA: "Terminal Lock",
      map: "Map",
      log: "Log",
      addTer: "Add device",
      detailTer: "Terminal details",
      riskInfo: "Risk control information",
      runLog: 'Running log',
      appList: 'APP list',
      appInstall: 'Application install',
      otaLock: 'OTA lock',

    },
    advertManage: "Advertisement",
    advertManageSub: {
      list: "List",
      examine: "Review",
      examineVideo: 'Videos',
      examineDetail: "Review details",
      edit: "Edit ad",
      editVideo: 'Edit video ad',
      detail: "Ad details",
      vlist: "Video Advertisement",
      vverify: "Video Review",
      addVideo: "Add Video ad",
      dfVList: "Default video list",
      addDfVideo: "Add default video"
    },
    appManage: "Application",
    appManageSub: {
      list: "APP List",
      market: "APP Market",
      custom: "Add to my customization",
      viewApp: "View application",
      customPush: "Custom push",
      appPush: "App push",
      appBind: "Install Application remotely",
      examine: "Application Review",
      verifyApp: "Review Application",
      appEdit: 'Application edit',
      appDetail: 'Application details',
      uploadNew: 'Upload new version',
      uploadApp: 'Upload application'
    },
    //20170807 add
    safeManage: "Security",
    safeManageSub: {
      certificate: "Certificate List",
      certNew: "Create certificate",
      remote: "Remote authorization",
      certUpload: "Upload vendor certificate",
      certDetail: "Certificate details",
      cerUpload: "Upload certificate",
      myCert: 'My certificate'
    },
    taskManage: "Task",
    taskManageSub: {
      list: "In process",
      detail: "Task details",
      listHis: "Finish",
      detailHis: "Task details"
    },
    dataManage: "Data",
    dataManageSub: {
      channel: "Merchant",
      factory: "Manufacture",
      terClassify: "Device Type",
      terNum: "Device Model",
      advertClassify: "Advertisement Type",
      appClassify: "Application Type",
      newChannel: "Add merchant",
      editChannel: "Edit merchant",
      newFirm: "Add manufacture",
      editFirm: "Edit manufacture"
    },
    railManage: "Risk Control",
    railManageSub: {
      penSetting: "Fence set",
      warnSetting: "Warning information",
      riskDetail: "Fence details",
    },
    sysManage: "System",
    sysManageSub: {
      romul: 'OTA upload',
      romed: 'OTA edit',
      romOTA: "OTA List",
      examine: "OTA Review",
      push: "OTA Push",
      order: "System Custom",
      animation: "Boot animation custom",
      animateCustom: "Custom animation",
      animatePush: "Aanimation push",
      pushHistory: "Push History",
      firmwareManage: 'Firmware List',
      firmwareUpload: 'Firmware Upload',
      firmwareEdit: 'Firmware Edit',
      firmwareCheck: 'Firmware Review',
      firmwareCheckDt: 'Firmware Details',
      firmwarePush: 'Firmware Push',
      firmwarePushDevice: 'Firmware push to device',
      launchManage: 'Launcher List',
      launchCheck: 'Launcher verify',
      launchEdit: 'launcher edit',
      launchNewVer: 'launcher upload new version',
      verifyLaunch: 'Verify launcher',
      addLaunch: 'Add launcher',
      launchDetail: 'Launcher detail',
      launchPush: 'Launcher push',
      launchPushTer: 'Launcher push to terminal',
    },
    setManage: "Config",
    setManageSub: {
      role: "Role List",
      system: "System configuration",
      menu: "Menu list",
      logo: 'LOGO setting'
    },
    accManager: "Account",
    accManagerSub: {
      account: "Account Info",
      subAccount: "Sub-account Info",
      addAccount: 'Add sub account',
      editAccount: 'Edit sub account',
    },
    menuEdit: 'Menu edit'
  },
  /*菜单 END*/
  /*广告*/
  advert: {
    status: "Status",
    addAdvert: "New Advertisement",
    deleteAll: "Batch Delete",
    all: "All",
    refusal: "Explain the reason",
    app: "Application",
    appSub: {
      name: "Name",
      classify: "Type",
      uploadTime: "Upload time",
      version: "Version"
    },
    isPass: "Result",
    pass: "Approved",
    notPass: "Rejected",
    waitOne: "Waiting for submit",
    waitTwo: "Waiting for review",
    addDate: "Add time",
    addUser: "Adders",
    appName: "Application name",
    img: "Image",
    name: "Name",
    classify: "Type",
    position: "Placement",
    positionSub: {
      banner: "Home Banner",
      starPage: "Start page"
    },
    jumpType: "Redirection",
    jumpTypeSub: {
      net: "Web page",
      appStore: "Application market"
    },
    url: "URL",
    channel: "Merchant",
    ableDate: "Expire Time",
    beginDate: "Start Time",
    endDate: "End Time",
    contentImg: "Content",
    reset: "Reset"
  },
  /*广告 END*/
  /*首页*/
  index: {
    t: "",
    more: "More",
    terStatus: "Device profile",
    onlineTer: "Online device",
    offLineTer: "Offline device",
    warnTer: "Warnning device",
    taskList: "Task list",
    pullApp: "Application issue",
    romUpdate: "ROM update",
    pullAdvert: "Ad push",
    infoList: "Information list",
    riskWarn: "Risk control warning",
    breakWarn: "Fault warning"
  },
  /*首页 END */

  /*配置管理*/
  menuConfig: {
    menu: {
      addMenu: "Add parent menu",
      addMenu2: "Add menu",
      refreshMenu: "Refresh menu",
      menuName: "Menu name",
      selectModel: "Please select the module",
      orderBy: "Sorting serial number",
      notBlankName: "Name cannot be null",
      editMenu: "Edit menu",
      editSuccess: "Edit sucessfully",
      addSubMenu: "Add submenu",
      relUrl: "Relative address"
    },
    // 配置管理 - 角色管理 Configuration management - Role management
    role: {
      addRole: "Add roles",
      no: "Number",
      name: "Name",
      mark: "Description",
      model: "Module",
      updatePermission: "Modify permissions",
      editRole: "Role edit",
      notBlankName: "Name cannot be null",
      updateSuccess: "Update successfully",
      deleteSuccess: "Delete successfully",
      modelSelect: "Module select",
      addSuccess: "Add successfully"
    }
  },
  /*配置管理 end*/
  /* 任务管理 */
  /* add by sing, 2017-10-26 */
  taskTypeNames: {
    ALL: "All Types",
    APP: "APP",
    OTA: "OTA",
    ROM: "ROM",
    FIRMWARE: "Firmware",
    AD: "AD",
    STARTUP_ANIMATION: "Startup Animation",
    SHUTDOWN_ANIMATION: "Shutdown Animation",
    STARTUP_SHUTDOWN_ANIMATION: "StartUp & Shutdown Animation",
    LOGO: "LOGO",
    LAUNCHER: "Launcher",
    WALLPAPER: 'WallPaper'
  },

  app_adname: 'Advertisement name',
  app_allpush: 'Push all of them',
  app_fipush: 'File import push',
  app_isjtoviewtd: 'Toggle to task list page',
  app_mgsys: 'System Host',
  app_edcode: 'Maintenance authorization code',
  app_sapp: 'Please choose the application',
  app_spic: 'Please select the picture',
  app_iappnamesrch: 'Please enter the application name query',
  app_alltyps: 'All types',
  app_allpp: 'All playback position',
  app_addur: 'Advertising time',
  app_vsize: 'Video size',
  app_addtime: 'Add time',
  app_psverify: 'Pass',
  app_vpreview: 'Video Preview',
  app_cstandt: 'Selection length and number of times',
  app_additv: 'Add time length',
  app_vdofile: 'video file',
  app_filename: 'File name',
  app_vdodur: 'Video time length',
  app_clreulvdo: 'Clicking on re - uploading video',
  app_adddfvdeoad: 'Add default video ads',
  app_addps: 'Additions',
  app_pltimes: 'Number of playback',
  app_pldur: 'Playback length',
  app_csvldate: 'Choice of validity period',
  app_advdoad: 'Adding video ads',
  app_mgdfvdo: 'Manage default video',
  app_adstatus: 'Advertising state',
  app_addadtype: 'New type of advertising',
  app_newapptype: 'New application type',
  app_addmodel: 'New model',
  app_newdvtype: 'New type of device',
  app_addfmname: 'New vendor name',
  app_srpush: 'Push',
  app_ulfile: 'Uploading files',
  app_ttpsddvnum: 'This push completes the number of equipment',
  app_srsktsdv: 'You are sure to skip these devices',
  app_cvpush: 'No, cover them',
  app_skpush: 'Yes, exclude them',
  app_pssuccess: 'Push successfully',
  app_nowjump: 'Ok',
  app_bcrecov: 'Batch reduction',
  app_skintro: 'Brief',
  app_addlc: 'New launcher',
  app_ulinsfile: 'Upload installation file',
  app_clreul: 'Click re - Upload',
  app_lcname: 'Launcher name',
  app_rsfivemin: 'Automatically refresh every 5 minutes',
  app_suresm: 'Confirm',
  app_udfiletype: 'Update file type',
  app_plsltype: 'Please select the type',
  app_adnamenotnull: 'The name of the advertisement cannot be empty',
  app_plslchannel: 'Please choose the channel dealer',
  app_plslplpos: 'Please select the playback location',
  app_slsttime: 'Please choose the start time',
  app_slendtime: 'Please choose the end time',
  app_addsc: 'Add success',
  app_vlsuccess: 'Audit success',
  app_opsuccess: 'Successful operation',
  app_srpassvf: 'Confirm through audit',
  app_addvdoad: 'Adding video ads',
  app_edvdoad: 'Editing video ads',
  app_sllimit: 'Choice of validity period',
  app_srmuldel: 'Confirm batch deleting',
  app_sttcanlateendtime: "The start time can't be later than the end time",
  app_etcanelsttime: 'The end time is not earlier than the start time',
  app_srdelpush: 'Confirm delete push',
  app_srrecovsysdf: 'Verify that the restore is default to the system',
  app_rdless: 'The radius of the fence is less than',
  app_srban: 'Confirm that it is not passed',
  app_banandrs: 'Do not pass? Please enter the reason for rejecting',
  app_trjmap: 'Track map',
  app_psdonelftip: 'There are {num} devices that have installed or in downloading. Exclude these devices?',
  app_psscandtip: 'Prompt install when finish download',
  app_csulpicbsis: 'Click Select to upload the picture, the best display size is',
  app_srch: 'Search',
  app_lkdevice: 'Find device',
  app_app: 'application',
  app_firmw: 'firmware',
  app_refresh: 'refresh',
  app_sleep: 'Sleep',
  app_ccdown: 'Cancel',
  app_iscancelPush: 'Whether to cancel the push?',
  app_fmVerIillegal: 'The version is not legal, it must be a number, such as 1.0.0',
  app_verror: 'Version exception',
  app_other: 'Others',
  app_inssuccess: 'Installation success',
  app_tipterop: 'Prompt terminal operation',
  app_autocmpl: 'Automatic completion',
  app_noresetfs: 'The device is in factory state, please contact the administrator to clear',
  app_saleSt: 'Factory state',
  app_actst: 'Activation state',
  app_insfail: 'Installation failure',
  app_checksignfail: 'Check failure',
  app_asc: 'Ascending',
  app_desc: 'Descending',
  app_utasc: 'Update time in ascending order',
  app_utdesc: 'Update time descending',
  app_srchcontent: 'Search content',
  app_account: 'accounts',
  app_opecontent: 'Operation content',
  app_opetime: 'Operation time',
  app_frzaccount: 'Ice knot account',
  app_operator: 'Operator',
  app_userip: 'User IP',
  app_deskwp: 'Wallpapers',
  app_channelmcdetail: 'Details of channel merchants',
  app_channellevel: 'Channel level',
  app_cermanage: 'Certificate management',
  app_lineimportcer: 'Line import certificate',
  app_devicemanage: 'device management',
  app_fileimportdevice: 'File importing device',
  app_lineimportdevice: 'Production line importing equipment',
  app_prodmodel: 'Product model',

  app_plimportcer: 'Production line import customer certificate',
  app_importslorder: 'Import the selected order',
  app_importslcustomer: 'Importing selected customers',
  app_customername: 'Customer name',
  app_orderno: 'Order number',
  app_orderfinishdate: 'Order completion date',
  app_customerno: 'Customer code',

  app_debuginfo: 'Develop information',
  app_adbstatus: 'ADB status',
  app_on1: 'On',
  app_off1: 'Off',
  app_devicemode: 'Device mode',
  app_normalmode: 'Normal',
  app_debugmode: 'Develop',
  app_signstatus: 'Sign activated',
  app_catchlog: 'Grab log',
  app_tobenimportdv: 'Soon to import equipment',
  app_lineimporttip: 'please set the type of equipment, manufacturer, model, address and other basic data',
  app_cannotwithsysapp: 'No system applications can be included',
  app_locktime: 'Locking time',

  app_risksetting: 'Wind control setting',
  app_lockinfo: 'Locking information',

  app_riskdetail: 'Details of early warning',
  app_lockcity: 'Lock the city',
  app_locklngandlat: 'Lock-in latitude and longitude',
  app_lockstate: 'Lock situation description',
  app_bindenclosure: 'Binding enclosure',
  app_unbindenclosure: 'Tie up a fence',
  app_sureunlock: 'Confirm unlocking',
  app_plsinputimgfile: 'Please upload the IMG format file',

  app_animatefile: 'Animated file',

  app_bglock: 'Backstage lock',
  app_request: 'Have applied',
  app_unrequest: 'Not applying for',

  app_lockdevice: 'Remotely lock',
  app_pusheddvlist: 'Uninstall application',
  app_appuninstall: 'Apps Uninstall',

  app_unlocked: 'Unlocked',
  app_unlockdevice: 'Unlocking equipment',
  app_misstokentip: 'Missing login information requires a re login authorization',

  app_pushnumcantfive: 'Maximum limit of install for one time is 5',
  app_selectedappshoupass: 'The selected application must be approved',

  app_adRefreshfreq: 'Advertising refresh frequency',

  app_uninsfail: 'Uninstall Failed',
  app_uninssc: 'Uninstall success',
  app_preversion: 'Basic version',
  app_rdneedmore: 'The radius of the fence should be greater than',

  app_addstfile: 'Add configuration file',
  app_filetag: 'File identification',

  app_filestss: 'Configuration description',
  app_uploadfilest: 'Upload configuration file',
  app_excludeapp: 'Exclusion application',
  app_reupload: 'Re - Upload',
  app_excludefsttip: 'Enter application package name to exclude this application. All applications that support the identification can use this configuration by default.',

  app_limitxml: 'Limit XML file',
  app_configfile: 'configuration file',

  app_udversion: 'Updated version',

  app_udsamexml: 'Only update the same identity XML',
  app_udxmllowertip: 'The updated version is lower than the current version and will appear in the historical record, not displayed in the list.',

  app_childacmg: 'Child account management',

  app_unldvwftip: 'The device is bound to the fence [{wl}]. Do you want to delete the binding at the same time?',

  app_udmode: 'Update mode',
  app_append: 'Append',

  /*** 非智能设备管理 */
  app_importapp: 'Import application',
  app_adddate: 'Create Time',
  app_addtask: 'Add tasks',
  app_addtesttask: 'Add task test',
  app_appdesc: 'Application description',
  app_srcdesc: 'Resource description',
  app_downapp: 'Download application',
  app_downfile: 'Download',
  app_addsrc: 'Add resources',
  app_importsrc: 'Import resources',
  app_srcname: 'Resource name',
  app_srcver: 'Resource version',
  app_downsrc: 'Download resources',
  app_number: 'number',
  app_softinfo: 'Software information',
  app_allstatus: 'All state',
  app_mstype14: 'Scavenging gun application push',
  app_mstype15: 'Scavenging gun resource file push',
  /*** end */

  app_filedesc: 'File description',
  app_filetype: 'file type',
  app_subtype: 'Subtype',
  app_addfile: 'Add a file',
  app_stmgpsw: 'Management password configuration',
  app_mapsl: 'Map selection',
  app_bdmap: 'Baidu Maps',
  app_map: 'Map',
  app_right: 'Jurisdiction',
  app_addconfig: 'Add configuration',
  app_editconfig: 'Edit configuration',
  app_mgpsw: 'Admin password',
  app_dvconfiglist: 'Configuration device list',
  app_appconfigst: 'Configuration application state',
  app_applytime: 'Apply time',
  app_secrname: 'Key name',
  app_secrdesc: 'Key description',
  app_addsecrrule: 'Add key rules',
  app_editsecrrule: 'Edit key rule',
  app_secrdvlist: 'Key device list',
  app_secrupdatest: 'Key update state',
  app_waitupdate: 'To be updated',


  app_addrandport: 'Address and port',
  app_filepath: 'File path',
  app_queryudfre: 'Query update frequency',
  app_lcupload: 'Local upload',
  app_hour: 'hour',
  app_addofcloud: 'Cloud add',
  app_bglist: 'Backstage list',
  app_cntype: 'Connection mode',
  app_codegunsrc: 'Scavenging gun resources',
  app_rtosgunsrc: 'RTOS resources',

  app_rots_1: "app",
  app_rots_2: "source",
  app_rots_3: "system",
  app_rots_4: "Security chip firmware version",
  app_rots_5: "Master version",

  app_partpkg: 'Incremental packet',
  app_codegunapp: 'Application of scavenger gun',
  app_starttime: 'start time',

  app_oilmcsrc: 'Tanker resources',

  app_downtpl: 'Download template',

  app_plsstype: 'Please select subtypes',

  app_allstyps: 'All subtypes',

  app_ftooltip: 'Animated /LOGO file online making tool',

  app_appendpush: 'Additional push',

  app_ipitonlylgchar: 'Entries can only be legal characters such as English digits and underscores.',

  app_enable: 'Enable',

  app_spfileis: 'File support format',

  app_cnsetting: 'connections setting up',

  app_newtask: 'New task',
  app_adddv: 'Add device',
  app_fileinsst: 'File installation configuration',
  app_insscautoop: 'Install successfully automatically open',
  app_pushsctipins: 'Push successful prompt installation',
  app_total: 'Total',
  app_wait: 'wait for',
  app_pushing: 'Pushing',
  app_pushsldev: 'Push the selected equipment',

  app_wite_update: "Wait for update",
  app_Update_successfully: "Update successful",
  app_Update_failure: "Update failed",

  app_repushdv: 'Re-push failed device',
  app_outputdv: 'Export equipment',

  app_udtime: 'Update time',
  app_surepsxdv: 'Confirm the push of {num} equipment',
  del_allData: "Do you want to delete all data?",
  app_apppush: 'Application push',
  app_fmwpush: 'Firmware push',
  app_advpush: 'Advertising push',
  app_onampush: 'Launch animation push',
  app_offampush: 'Shutdown animation push',
  app_onoffampush: 'Switch machine animated push',
  app_onlgpush: 'Boot logo push',
  app_wppush: 'Wallpaper push',
  app_stfpush: 'Configuration file push',
  app_codemc: 'Scavenger',
  app_codemcsrc: 'Scavenger resources',
  app_sysud: 'System update',
  app_fmwud: 'Firmware Update',
  app_anmud: 'Animation update',
  app_qcgunsrcps: 'Scavenging gun resource push',
  app_iscltask: 'Determine the cancellation of the task',
  app_resrc: 'Resources',
  app_srcfileps: 'Resource file push',
  app_fmVerIillegal1: 'The version number is not legal. It must be carried with V and numbers, such as v1.0.0',

  app_helptip: 'Help reminding',
  app_newpsetnewver: 'New version of TMS push function entry revision',
  app_newptdetail: '	After the push function is revamped, users need to push to open the push task page (task management → push task), click on the new task, enter the new task page, enter the task name and select the file to push to create a new push task.',
  app_newptdetail1: '	The user can push the device in batches or single device push. The user can add the device many times in the task details. We suggest that the user push a small number of devices before the mass push, confirm the correctness, click on the add device in the task details and then push a large number of devices. Send.',

  app_daterange: 'Date range',
  app_olinepday: 'Daily online quantity',
  app_onlineavgt: 'Average online time interval',
  app_devicewhe: 'Equipment distribution',
  app_statistic: 'Statistics',
  app_today: 'today',
  app_thisweek: 'This week',
  app_thismonth: 'This month',

  app_addblfile: 'Add blacklist file',
  app_blacklsname: 'Blacklist name',
  app_editblls: 'Edit blacklist',
  app_blsdesc: 'Blacklist description',
  app_blsdvlist: 'Blacklist device list',

  app_wldesc: 'Enclosure description',
  app_filectncr: 'The contents of the file are incorrect.',

  app_khour: 'hour',
  app_kday: 'day',
  app_yesterday: 'yesterday',
  app_rc15d: 'The last 15 days',
  app_rc30d: 'The last 30 days',
  app_stinfo: 'status information',

  app_croln: 'Current online',
  app_crslp: 'Current dormancy',
  app_croff: 'Current offline',
  app_lstol: 'Last online time',
  app_lstsl: 'Last dormancy time',
  app_lstof: 'Last offline time',
  app_limitiplg: 'Restricted IP segment logon',
  app_illegal: 'Wrongful',
  app_limitiptip: 'Please enter the IP segment that needs to be restricted.',
  app_unknow: 'Unknown',
  app_hisstatus: 'Historical state',
  app_allowiplg: 'Allow IP segment login',
  app_allowiptip: 'Please enter the allowed IP segment, and allow all IP access without input.',
  app_active1: 'active',
  app_unuse: 'not enabled',
  app_addpsg: 'Add passage',
  app_psgname: 'Passage name',
  app_authstat: 'Authorization state',
  app_cbackad: 'token url',
  app_bsrqsadwl: 'White address of business request address',
  app_appwtls: 'App white list',
  app_addapppgkn: 'Add application package name',
  app_authopen: 'Authorization to open',
  app_authclose: 'Authorized closure',
  app_addaddr: 'Add the address',
  app_developer: 'developer',
  app_editpasg: 'Edit passage',
  app_usertype: 'customer type',
  app_generate: 'generate',
  app_gentip: 'After regenerating AppSecret, the original AppSecret will fail and will not be able to continue to access the open platform. Is it necessary to regenerate AppSecret?',
  app_open1: 'open',
  app_hide: 'hide',
  app_subtask: 'Subtask',
  app_sltstype: 'Select task type',
  app_command: 'instruction',
  app_addsubts: 'Add subtasks',
  app_commtype: 'Instruction type',
  app_taskpros: 'Task schedule',
  app_cursubts: 'Current subtasks',
  app_commpush: 'Instruction push',
  app_dvrestart: 'Reboot of equipment',
  app_recvorgst: 'Restore factory settings',
  app_recvanimt: 'Restore animation',
  app_dvlock: 'Equipment lock machine',
  app_dvunlock: 'Equipment unlocking',
  app_inbdside: 'It s already on the border.',
  app_subtsnum: 'Number of sub tasks',
  app_tscrtime: 'Task creation time',
  app_ing: 'Have in hand',
  app_core: 'kernel',
  app_filesys: 'file system',
  app_commd1fw: 'Communication module 1 firmware',
  app_commd2fw: 'Communication module 2 firmware',
  app_readcfw: 'Card reader firmware',
  app_pswkbfw: 'Password keyboard firmware',
  app_scanhfw: 'Scan head firmware',
  app_actpossp: 'Activate POS call',
  app_natpossp: 'Close POS calls',
  app_setcallf: 'Set up call function',
  app_clupappdt: 'Clear application data',
  app_isclupappdt: 'Determine Clearance of Application Data',
  app_impdistbt: 'Introducing Channel Businessmen',
  app_impmctip: 'To upload files, only support excel and no more than 10m',
  app_callfunc: 'Call function',

  app_protocal: 'prototal',
  app_prtsltip: 'When selecting HTTPS, you must ensure that the interface supports this protocol.',
  app_rgsvpm: 'Authorization service parameters',
  app_rgsvip: 'Authorization Service IP',
  app_bgntpm: 'Background notification parameters',
  app_bgntip: 'Background notification IP',
  app_port: 'port',
  app_flexist: 'file already exist',
  app_delcer: 'Delete certificate',
  app_cerid: 'Certificate fingerprint',
  app_wallpaper: 'wallpaper',

  app_forceins: 'Mandatory installation',
  app_autorun: 'Launch after installation',
  app_cusins: 'Customized Installation',
  app_cusuins: 'Customized unloading',
  app_forcerun: 'Enforcement',
  app_pushtest: 'Push test',
  app_pltfblt: 'Platform Bulletin',

  app_addblt: 'Add announcement',
  app_blttt: 'Notice title',
  app_readnum: 'Reading times',
  app_bltct: 'Announcement content',
  app_pltudrd: 'Platform has been updated',
  app_udlog: 'Update log',
  app_addver: 'Add version',
  app_pubdate: 'Release date',
  app_updct: 'Update content',
  app_editblt: 'Edit notice',
  app_editver: 'Edit version',
  app_verupdate: 'Version update',
  app_clviewdt: 'Click here for details',
  app_viewmore: 'View more',
  app_comptime: 'Compile time',
  app_insafnorun: 'Non-automatic operation after installation',
  app_normalins: 'General installation',
  app_normalunins: 'General unloading',
  appp_tipoperate: 'Prompt operation',
  app_onlyprov: 'Select provinces only',
  app_filepush: 'File push',
  app_region: 'region',
  app_srcmechan: 'Input keyword search channel quotient',
  app_ckcode: 'Verification Code',
  app_cantuins: 'Uninstall',
  app_ippkgname: 'Input package',
  app_onlypicfm: 'Only upload image format files (JPG, PNG, GIF...)',
  app_fludlist: 'File Update List',
  app_param: 'parameter',
  app_catching: 'Grabbing',
  app_ulding: 'Uploading',
  app_ulyet: 'Upload completed',
  app_endcatch: 'End grab',
  app_iscatch: 'Make sure to start grabbing？',
  app_opterinfo: 'Export terminal information',
  app_bcopterinfo: 'Batch export information',
  app_cpttime: 'Interception time',
  app_eqcapture: 'Device screenshots',
  app_scapture: 'Screenshots',
  app_surestcap: 'Determine to take screenshots？',
  app_lokscrn: 'lock screen ',
  app_ulkscrn: 'extract screen ',
  app_appautrn: 'App auto starts ',
  app_perms: 'Unit: milliseconds',
  app_wattime: 'Waiting time',
  app_lcswitch: 'Launcher switch',
  app_appadv: 'App advertisement',
  app_cardno: 'Card number',
  app_trdno: 'Serial number',
  app_batcno: 'Batch number',
  app_amout: 'Amount',
  app_mechno: 'Merchant number',
  app_trdtime: 'Transaction time',
  app_trddate: 'Transaction date',
  app_trdcore: 'Core stream',
  app_expno: 'Reference number',
  app_trdtype: 'Transaction type',
  app_rectime: 'Record time',
  app_fpaddrs: 'Face image address',
  app_propcut: 'Cut to scale',
  app_getcash: 'get cash',
  app_lctrans: 'intra bank transfer',
  app_obtrans: 'transfer to another bank',
  app_coretrans: 'core stream',
  app_tradeNo: 'transaction number',
  app_export: 'Export',
  app_ctrc: 'Magnetic stripe card reader',
  app_icrc: 'IC card reader',
  app_prtst: 'Printer status',
  app_pswkb: ' Password keyboard',
  app_idfrc: 'ID card reader',
  app_led: 'LED',
  app_beep: 'buzzer',
  app_codebar: 'barcode',
  app_lulog: 'View log',
  app_lust: 'View status',
  app_mdclst: 'module call statistics',
  app_fcclst: 'method call statistics',

  app_acauth: 'Activation code authorization',
  app_authcode: 'Activation code',
  app_authrange: 'Validity of procedure',
  app_delact: 'Do not activate',
  app_pswtip: 'The password must have more than 8 digits, including upper case letters, lower case letters, numbers and special symbols',
  app_mulfcau: 'Multi factor authentication',
  app_verifc: 'verification',
  app_opmfackip6dycode: 'Please open the MFA verifier and enter the 6-digit dynamic verification code',
  app_cantprvmcodectadm: 'If you cannot provide multi factor authentication verification code, please contact the administrator',
  app_lsstep: 'Previous step',
  app_nxstep: 'Next step',
  app_ckidt: 'Verify identity',
  app_istapp: 'Install application',
  app_bindmfa: 'Bind MFA',
  app_ipaclgpsw: 'Enter account login password',
  app_bindsfdv: 'Bind security device',
  app_psfwtsstepop: 'Please complete the binding operation as follows',
  app_sixnumb: '6 numbers',
  app_phdnalyappggidck: 'Please download and install the Aliyun APP/Google Authenticator APP on your phone',
  app_ipappstsagidck: 'iphone: Search for Aliyun APP/Google Authenticator APP in AppStore',
  app_adappmksagidck: 'Android : Search for Aliyun APP/Google Authenticator APP in the app market',
  app_afistclnxitbpagiinx: 'Click "Next" to the binding page after finishing installing the Aliyun APP/Google Authenticator APP. ( if installed, Click "Next" directly)',
  app_usalyagidckscqrc6code: 'Use the Aliyun APP/Google Authenticator APP to scan the following two-dimensional code to get a 6-digit verification code',
  app_sftkck: 'MFA verification',
  app_ip6codeubac: 'input the 6-digit verification code to unbind accoun',
  app_plipopenalyappoggidckip6dycd: 'Please open the Google Authenticator app in your phone and enter your 6-digit dynamic code',

  app_select_timelist: "Select the time range",
  app_batch_migration: "Batch Migration",
  app_expired_button: "Expired in the last 7 days",
  app_sure_migration: "Confirm the migration",

  app_Batch_import: "Batch import",
  app_Batch_push: "Batch export",
  app_input_sn: "Please enter serial number",
  app_serialnumber: "Device number",
  app_serialnumber_new: "New device number",
  app_termin_status: "Device update status",
  app_status_update: "To be updated",
  app_status_updated: "Have been updated",
  app_status_exist: "Key already exists",
  app_status_fail: "Fail",

  app_dyf: "Did you ever file 21",
  app_wtk: "Whether there is a key",
  app_keyType: "Key type",
  app_keyUpIndex: "Encryption key index",
  app_keyDlIndex: "Download Key index",
  app_Algorithm_mode: "Algorithm pattern",


  app_start_no: "TerminalNo start",
  app_end_no: "TerminalNo end",

  auth_status_list: {
    status_1: "In the process of authentication",
    status_2: "Authentication failed",
    status_3: "Generate activation code",
    status_4: "The activation code has expired",
    status_5: "Activation successful",
    status_6: "Activation failed",
  }
}

export default en;



// WEBPACK FOOTER //
// ./src/components/language/en.js